function initializeProductRecommendations(section) {
  if (!section || section.dataset.recommendationsReady === 'true') return;

  section.dataset.recommendationsReady = 'true';

  const loadRecommendations = async () => {
    try {
      const response = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshSection = html.querySelector('[data-product-recommendations]');
      if (!freshSection || !freshSection.querySelector('[data-recommendation-list]')) return;

      section.replaceWith(freshSection);
    } catch (_error) {
      // Recommendations are optional merchandising; keep the empty section hidden.
    }
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      },
      { rootMargin: '0px 0px 300px 0px' },
    );

    observer.observe(section);
  } else {
    loadRecommendations();
  }
}

document.querySelectorAll('[data-product-recommendations]').forEach(initializeProductRecommendations);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-recommendations]').forEach(initializeProductRecommendations);
});
